import React from "react";
import FormSectionCard from "./FormSectionCard";
import InputText from "../InputFields/InputText";
import { Files } from "../Files";
import { DisplayImage } from "../Files/DisplayFiles";

/**
 * Internal Notes + file upload — same bordered section as Line Items (`FormSectionCard`).
 * Supports either `notes` + `setNotes` or Formik-style `value` + `onChange` + `onBlur`.
 */
export default function InternalNotesAttachments({
  notes,
  setNotes,
  value,
  onChange,
  onBlur,
  attachments,
  setAttachments,
  noBorder = false,
  notesLabel = "Internal Notes",
  placeholder = "Enter notes",
  title = "Internal Notes and Attachments",
  name = "Notes",
  error,
  helperText,
  showErrorOnly,
  multiline = true,
  minRows = 3,
}) {
  const controlledValue =
    value !== undefined && value !== null ? value : notes ?? "";

  const handleNoteChange = (event) => {
    let v = event?.target?.value;
    if (v?.length === 1 && v.startsWith(" ")) {
      return;
    }
    if (onChange) {
      onChange(event);
      return;
    }
    if (setNotes) {
      setNotes(v);
    }
  };

  return (
    <FormSectionCard title={title} noBorder={noBorder}>
      <InputText
        className="w-100"
        name={name}
        label={notesLabel}
        placeholder={placeholder}
        value={controlledValue}
        onChange={handleNoteChange}
        onBlur={onBlur}
        multiline={multiline}
        minRows={minRows}
        fullWidth
        error={error}
        helperText={helperText}
        showErrorOnly={showErrorOnly}
      />
      <Files files={attachments} setFiles={(v) => setAttachments(v)} />
      <DisplayImage
        files={attachments}
        setFiles={(v) => setAttachments(v)}
        IsDeleted={true}
      />
    </FormSectionCard>
  );
}
